'use client'

import React from 'react'

import { AdminBarDocumentProvider } from '@/components/AdminBar/AdminBarDocumentContext'
import AdminDomExtensionSanitizerProvider from '@/components/payload/admin/AdminDomExtensionSanitizerProvider'

import {
  CATEGORY_ARCHIVE_SEGMENT,
  SHOW_CATEGORY_BASE_IN_SLUG,
  TAG_ARCHIVE_SEGMENT,
} from '@/constants/taxonomyRoutes'

import { TaxonomyArchivePathsProvider } from './TaxonomyArchivePathsContext'
import { ThemeProvider } from './Theme'
import type { Theme } from './Theme/types'

export const Providers: React.FC<{
  children: React.ReactNode
  /** Tema inicial do servidor (cookie / Client Hints), alinhado a `<html data-theme>`. */
  ssrInitialTheme: Theme
  /** Alinha links do cliente com «Mostrar o prefixo das categorias no slug» (SEO global). */
  showCategoryBaseInSlug?: boolean
  /** Bases de URL em `postUrlSettings` (arquivos de taxonomia). */
  categoryUrlBase?: string
  tagUrlBase?: string
}> = ({ children, ssrInitialTheme, showCategoryBaseInSlug, categoryUrlBase, tagUrlBase }) => {
  return (
    <AdminDomExtensionSanitizerProvider>
    <ThemeProvider ssrInitialTheme={ssrInitialTheme}>
      <TaxonomyArchivePathsProvider
        showCategoryBaseInSlug={
          typeof showCategoryBaseInSlug === 'boolean' ? showCategoryBaseInSlug : SHOW_CATEGORY_BASE_IN_SLUG
        }
        categoryUrlBase={
          typeof categoryUrlBase === 'string' && categoryUrlBase.trim()
            ? categoryUrlBase.trim().toLowerCase()
            : CATEGORY_ARCHIVE_SEGMENT
        }
        tagUrlBase={
          typeof tagUrlBase === 'string' && tagUrlBase.trim()
            ? tagUrlBase.trim().toLowerCase()
            : TAG_ARCHIVE_SEGMENT
        }
      >
        <AdminBarDocumentProvider>{children}</AdminBarDocumentProvider>
      </TaxonomyArchivePathsProvider>
    </ThemeProvider>
    </AdminDomExtensionSanitizerProvider>
  )
}

